<template>
  <v-card>
    <v-toolbar color="primary" flat dark dense>
      <v-toolbar-title class="ml-2">{{ reportTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div max-width="200px">
      <v-select
        small
        v-model="reportInputComponent"
        :items="availableReportComponents"
        ></v-select>
      </div>
    </v-toolbar>
    <v-card-text>
    <component
      v-bind:is="reportInputView"
      v-model="reportInput"
    >
    </component>
    </v-card-text>
    <v-card-actions>
    <v-btn
      v-if="supportsHtmlReport"
      :disabled="!allowQueryExecution"
      @click="generateReport"
      :dark="allowQueryExecution"
      color="primary"
    >Generate Report
     <v-icon class="pl-1">mdi-file-chart</v-icon>
    </v-btn>

    <v-btn
      v-if="supportsExcelReport"
      :disabled="!allowQueryExecution"
      @click="downloadExcelReport"
      :dark="allowQueryExecution"
      color="green darken-4"
    >
      Download Excel Report
      <v-icon class="pl-1">mdi-microsoft-excel</v-icon>
    </v-btn>

    <v-btn
      v-if="supportsCsvReport"
      :disabled="!allowQueryExecution"
      @click="downloadReport"
      :dark="allowQueryExecution"
      color="deep-purple darken-3"
    >
      Download CSV Report
      <v-icon class="pl-1">mdi-file-delimited</v-icon>
    </v-btn>

    </v-card-actions>
  </v-card>
</template>

<script>
import MonthInput from './MonthInput'
import TimeframeInput from './TimeframeInput'
import CampaignSelectInput from './CampaignSelectInput'
import EmailResponseInput from './EmailResponseInput'
import TimeframeAndCustomerTypeInput from './TimeframeAndCustomerTypeInput'

export default {
  name: 'report-input',
  components: {
    [MonthInput.name]: MonthInput,
    [TimeframeInput.name]: TimeframeInput,
    [CampaignSelectInput.name]: CampaignSelectInput,
    [EmailResponseInput.name]: EmailResponseInput,
    [TimeframeAndCustomerTypeInput.name]: TimeframeAndCustomerTypeInput
  },
  props: {
    value: {
      required: true,
      type: Object
    },
    allowQueryExecution: {
      require: true,
      type: Boolean
    },
    availableInputs: {
      require: false,
      type: Array,
      default: function () {
        return [MonthInput.name, TimeframeInput.name]
      }
    },
    supportsHtmlReport: {
      required: false,
      type: Boolean,
      default: true
    },
    supportsCsvReport: {
      required: false,
      type: Boolean,
      default: true
    },
    supportsExcelReport: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      reportInputComponent: MonthInput,
      newReportInputValue: null
    }
  },
  computed: {
    reportInputView () {
      return this.reportInputComponent.name
    },
    reportTitle () {
      return this.reportInputComponent.title
    },
    reportInput: {
      get () {
        return this.value
      },
      set (val) {
        this.newReportInputValue = val
      }
    },
    availableReportComponents () {
      return this.availableInputs.map(inputName => {
        const klass = this.$options.components[inputName]
        return { text: klass.displayName, value: klass }
      })
    }
  },
  watch: {
    availableReportComponents (newVal, oldVal) {
      const inputComponent = newVal.find(comp => comp.value.name === this.reportInputComponent.name)
      if (!inputComponent) {
        this.reportInputComponent = newVal[0].value
      }
    }
  },
  methods: {
    generateReport () {
      this.$emit('input', Object.assign({}, this.newReportInputValue, { outputFormat: 'html' }))
    },
    downloadReport () {
      this.$emit('input', Object.assign({}, this.newReportInputValue, { outputFormat: 'csv' }))
    },
    downloadExcelReport () {
      this.$emit('input', Object.assign({}, this.newReportInputValue, { outputFormat: 'excel' }))
    }
  },
  mounted () {
  }

}
</script>
